import { IonIcon } from '@ionic/react'
import { useStore } from 'effector-react'
import { closeCircleOutline, warning } from 'ionicons/icons'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { Modal, useModal } from '~/shared/ui/Modal'
import { myPalette } from '~/shared/ui/theme'
import { profileModel } from '../..'
import { createDeletionRequest, createDeletionRequestFx } from './model'
import { ButtonsWrapper, Field, ModalTitle, Title } from './styled'

type DriverDeletionDetailsDrawerProps = {
  isShow: boolean
  onClose: () => void
}

export function DriverDeletionDetailsDrawer({
  isShow,
  onClose,
}: DriverDeletionDetailsDrawerProps) {
  const { isModalShow, closeModal, openModal } = useModal()

  const isCreateDeletionRequestPending = useStore(
    createDeletionRequestFx.pending,
  )

  const handleCreateDeletionRequest = () => {
    createDeletionRequest({
      fn: () => {
        profileModel.closeProfileDrawer()
        onClose()
        closeModal()
      },
    })
  }

  return (
    <>
      <DrawerComponent isShow={isShow} onCancel={onClose}>
        <Title>Удаление аккаунта</Title>
        <Field>Для удаления вашего аккаунта, оставьте заявку на удаление</Field>
        <Field>
          Примечание: аккаунт будет удален вместе со всеми персональными
          данными, балансом и стажем. Восстановить доступ к аккаунту и данным
          после удаление будет невозможно.
        </Field>
        <Field>
          Важно: вы не можете удалить аккаунт имея активный договор или
          задолженности перед таксопарком.
        </Field>
        <Field>
          Процесс удаления занимает до 5 рабочих дней. По завершению вы будете
          проинформированы об успешном удалении аккаунта.
        </Field>

        <ButtonsWrapper>
          <Button fullWidth variant='lightSteelBlueBorder' onClick={onClose}>
            Отмена
          </Button>
          <Button
            onClick={openModal}
            variant='coralFlooded'
            fullWidth
            endDecorator={
              <IonIcon
                icon={closeCircleOutline}
                style={{ fill: myPalette.white.main }}
              />
            }
          >
            Удалить
          </Button>
        </ButtonsWrapper>
      </DrawerComponent>

      <Modal isShow={isModalShow} canBackdropClose={false}>
        <div style={{ textAlign: 'center' }}>
          <IonIcon
            icon={warning}
            style={{
              fill: myPalette.coral.main,
              width: '70px',
              height: '70px',
            }}
          />
        </div>
        <ModalTitle>Удаление аккаунта</ModalTitle>
        <div style={{ textAlign: 'center' }}>
          Вы уверенны что хотите удалить аккаунт?
          <br />
          Аккаунт будет удален вместе со всеми персональными данными, балансом и
          стажем. Восстановить доступ к аккаунту и данным после удаление будет
          невозможно
        </div>
        <ButtonsWrapper>
          <Button
            fullWidth
            variant='lightSteelBlueBorder'
            onClick={closeModal}
            disabled={isCreateDeletionRequestPending}
          >
            Отмена
          </Button>
          <Button
            onClick={handleCreateDeletionRequest}
            loading={isCreateDeletionRequestPending}
            variant='coralFlooded'
            fullWidth
            endDecorator={
              <IonIcon
                icon={closeCircleOutline}
                style={{ fill: myPalette.white.main }}
              />
            }
          >
            Удалить
          </Button>
        </ButtonsWrapper>
      </Modal>
    </>
  )
}
